"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTracker = exports.V4EventType = exports.SaEventType = exports.V4_EU_UPLOAD_DOMAIN = exports.V4_UPLOAD_DOMAIN = exports.container = exports.EventTracking = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
Object.defineProperty(exports, "container", { enumerable: true, get: function () { return event_tracking_core_1.container; } });
var event_tracking_behavior_adapter_1 = require("@al/event-tracking-behavior-adapter");
var event_tracking_sensor_analytics_1 = require("@al/event-tracking-sensor-analytics");
var inversify_config_1 = require("./inversify.config");
var EventTracking_1 = require("./EventTracking");
Object.defineProperty(exports, "EventTracking", { enumerable: true, get: function () { return EventTracking_1.EventTracking; } });
var event_tracking_behavior_adapter_2 = require("@al/event-tracking-behavior-adapter");
Object.defineProperty(exports, "V4_UPLOAD_DOMAIN", { enumerable: true, get: function () { return event_tracking_behavior_adapter_2.V4_UPLOAD_DOMAIN; } });
Object.defineProperty(exports, "V4_EU_UPLOAD_DOMAIN", { enumerable: true, get: function () { return event_tracking_behavior_adapter_2.V4_EU_UPLOAD_DOMAIN; } });
var types_1 = require("./types");
Object.defineProperty(exports, "SaEventType", { enumerable: true, get: function () { return types_1.SaEventType; } });
Object.defineProperty(exports, "V4EventType", { enumerable: true, get: function () { return types_1.V4EventType; } });
var hasTracker = false;
var createTracker = function (isNew) {
    if (hasTracker || isNew) {
        var c = new inversify_1.Container();
        (0, event_tracking_core_1.bindToContainer)(c);
        (0, event_tracking_behavior_adapter_1.bindToContainer)(c);
        (0, event_tracking_sensor_analytics_1.bindToContainer)(c);
        (0, inversify_config_1.bindToContainer)(c);
        return c.get(EventTracking_1.EventTracking);
    }
    hasTracker = true;
    return event_tracking_core_1.container.get(EventTracking_1.EventTracking);
};
exports.createTracker = createTracker;
